import { render, staticRenderFns } from "./mini_cart.vue?vue&type=template&id=16a86d50&"
import script from "./mini_cart.vue?vue&type=script&lang=js&"
export * from "./mini_cart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports